import { createRouter, createWebHistory } from 'vue-router';

const router = createRouter({
  // history: createWebHistory(import.meta.env.BASE_URL),
  history: createWebHistory(import.meta.env.VITE_BASE_URL || '/'),
  routes: [
    {
      path: '/new',
      name: 'home',
      component: () => import('../views/Chatgpt.vue'),
    },
    {
      path: '/',
      name: 'ChatGpt',
      component: () => import('../views/chatgpt/Chatgpt.vue'),
    },
    {
      path: '/c/:conversation_id',
      name: 'ChatGptConversation',
      component: () => import('../views/chatgpt/Chatgpt.vue'),
    },
    {
      path: '/share/:shareId',
      name: 'ChatGptShareConversation',
      component: () => import('../views/chatgpt/ShareDetail.vue'),
    },
    {
      path: '/old',
      name: 'home2',
      component: () => import('../views/AboutView.vue'),
    },
    {
      path: '/test',
      name: 'HomeView',
      component: () => import('../views/HomeView.vue'),
    },
    // {
    //     path: '/about',
    //     name: 'about',
    //     // route level code-splitting
    //     // this generates a separate chunk (About.[hash].js) for this route
    //     // which is lazy-loaded when the route is visited.
    //     component: () => import('../views/AboutView.vue'),
    // },
  ],
});

export default router;
